import { useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, Form, Pagination } from "react-bootstrap";
import classNames from "classnames";

import Notification from "../notification/Notification";
import Flex from "../common/Flex";
import { usePagination } from "../../utils/usePagination";

const ActivityLog = ({
  activities,
  setPage,
  totalCount,
  currentPage,
  pageSize,
}) => {
  const [pageTmp, setPageTmp] = useState(currentPage);
  const paginationRange = usePagination({
    currentPage: currentPage,
    totalCount: totalCount,
    siblingCount: 1,
    pageSize: pageSize,
  });
  return (
    <Card>
      <Card.Header className="bg-light">
        <Flex justifyContent="between">
          <h5 className="mb-1 mb-md-0">Activity log</h5>
        </Flex>
      </Card.Header>
      <Card.Body className="bg-light">
        {activities.length > 0 ? (
          activities.map((activity, index) => (
            <Notification
              {...activity}
              key={`${activity?.action}${index}`}
              className={classNames(
                "border-x-0 border-bottom-0 border-300",
                index + 1 === activities.length ? "rounded-top-0" : "rounded-0",
              )}
            />
          ))
        ) : (
          <p>No Logs found</p>
        )}
      </Card.Body>
      <Card.Footer>
        <Pagination
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <div style={{ display: "flex" }}>
            {paginationRange?.map((p) => (
              <Pagination.Item
                onClick={() => {
                  p !== "..." && setPage(p);
                }}
                active={currentPage === p ? true : false}>
                {p}
              </Pagination.Item>
            ))}
          </div>
          <div style={{ display: "flex", width: "146px" }}>
            <Form.Label
              className="mb-0 mx-2"
              style={{ flex: "1 1 1", width: "150px" }}>
              Go to Page
            </Form.Label>
            <Form.Control
              size="sm"
              as="input"
              style={{ width: "50px !important" }}
              value={pageTmp}
              onKeyPress={(e) => {
                if (e.code === "Enter") {
                  pageTmp <= Math.ceil(totalCount / pageSize)
                    ? setPage(parseInt(pageTmp))
                    : setPageTmp(currentPage);
                }
              }}
              onChange={(e) => {
                setPageTmp(e.target.value);
              }}
            />
          </div>
          <div>
            <Button
              className="mx-1"
              variant={currentPage > 1 ? "primary" : "light"}
              onClick={
                currentPage > 1
                  ? () => setPage((prevState) => prevState - 1)
                  : () => {}
              }>
              Previous
            </Button>
            <Button
              variant={
                currentPage < Math.ceil(totalCount / pageSize)
                  ? "primary"
                  : "light"
              }
              onClick={
                currentPage < Math.ceil(totalCount / pageSize)
                  ? () => setPage((prevState) => prevState + 1)
                  : () => {}
              }>
              Next
            </Button>
          </div>
        </Pagination>
      </Card.Footer>
    </Card>
  );
};

ActivityLog.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.shape(Notification.propTypes))
    .isRequired,
};

export default ActivityLog;
